import React, { useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../components/compounds/modalForm/ModalForm.compunds"
import PrimaryButton from "../../../components/molecules/buttons/PrimaryButton.molecule"
import SecondaryButton from "../../../components/molecules/buttons/SecondaryButton.molecule"
import { TEAM_MEMBER_ACTION_MODAL_MESSAGES } from "../../../consts/modules/teamMembers.consts"
import { ACTION_MODAL_ENTITY_NAME_MAX_CHARS } from "../../../consts/common.const"
import useToast from "../../../hooks/useToast.hook"
import { truncateWithEllipsis } from "../../../utils/strings.utils"

function getTeamMemberDisplayName(row) {
  if (!row) return ""
  const { firstName, lastName } = row
  return `${firstName} ${lastName}`
}

const TeamMembersActionModal = ({
  row,
  visible,
  setVisible,
  onFinishedSubmit,
}) => {
  const [submitting, setSubmitting] = useState(false)
  const { setErrorMessage } = useToast()

  const getModalMessage = () => {
    return (
      row === null ? TEAM_MEMBER_ACTION_MODAL_MESSAGES.DISABLE_TEAM_MEMBER
      : row.active ? TEAM_MEMBER_ACTION_MODAL_MESSAGES.DISABLE_TEAM_MEMBER
      : TEAM_MEMBER_ACTION_MODAL_MESSAGES.ENABLE_TEAM_MEMBER
    )
  }

  const modalContent = getModalMessage()
  const displayName = getTeamMemberDisplayName(row)
  const truncatedName = truncateWithEllipsis(
    displayName,
    ACTION_MODAL_ENTITY_NAME_MAX_CHARS
  )
  const titleLabel = modalContent.buildTitle(truncatedName)
  const showFullNameHint =
    displayName && truncatedName !== displayName ? displayName : undefined
  const headerTitle = <span title={showFullNameHint}>{titleLabel}</span>

  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const response = await modalContent.service({
        userId: row.userId,
        active: !row.active,
      })
      if (!response.success) {
        throw new Error("Error")
      }
      setVisible(false)
      onFinishedSubmit()
    } catch (error) {
      setErrorMessage({
        message: "Ha ocurrido un error al realizar la acción.",
      })
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <ModalForm
      visible={visible}
      setVisible={setVisible}
      headerIconClass="pi pi-info-circle"
      headerTitle={headerTitle}
      footer={
        <div>
          <SecondaryButton
            rounded
            label="Cancelar"
            onClick={() => setVisible(false)}
          />
          <PrimaryButton
            rounded
            icon={`pi ${submitting ? "pi-spin pi-spinner" : "pi-check"}`}
            label={"Aceptar"}
            onClick={handleSubmit}
            disabled={submitting}
          />
        </div>
      }
      service={handleSubmit}
    >
      <span>{modalContent?.description}</span>
    </ModalForm>
  )
}

export default TeamMembersActionModal

TeamMembersActionModal.propTypes = {
  row: PropTypes.object,
  visible: PropTypes.bool,
  setVisible: PropTypes.func,
  onFinishedSubmit: PropTypes.func,
}
